import styled from 'styled-components';

export const Container = styled.div`
	background: #fff;
	height: 100vh;
	color: #000;
	display: flex;
	flex-direction: column;
`;
export const Inner = styled.div`
	/* max-width: 300px; */
	margin: auto;
`;

export const ImageContainer = styled.div``;

export const Image = styled.img``;

export const Chat = styled.div`
	height: 60px;
	background: #000;
	display: flex;
	/* width: 320px; */
	width: 100%;
	align-items: center;
	justify-content: center;
`;

export const Text = styled.p`
	color: white;
`;
